<template>
  <div id="update-payment-page" v-if="pageDataFetched">
    <checkout-header
      :categoryFilter="{ display: false }"
      :shoppingBag="{ display: false }"
    >
    </checkout-header>

        <div id="body">
            <h3>{{ checkoutSharedContent.paymentDetails }}</h3>
            <p class="black bold"><span class="icon small inline lock"></span>&nbsp;{{ checkoutSharedContent.sslEncryption }}</p>
            <h5 class="margin-top-20">{{ checkoutSharedContent.selectPaymentMethod }}</h5>
            <payment-method :availablePaymentMethods="availablePaymentMethods"></payment-method>

      <submit-button
        position="center"
        mobile="12"
        tablet="3"
        desktop="3"
        styling="primary"
        @onClickEvent="submitUpdatePaymentData"
      >
        <template v-slot:content>
          {{ checkoutSharedContent.continue }}
        </template>
      </submit-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import axios from "axios";

import CheckoutHeader from "../../layouts/header";
import SubmitButton from "../../../utils/button";
import PaymentMethod from "../../checkout/payment-method";
import { analyticsTrack } from "../../../../plugins/segment";

export default {
  components: { CheckoutHeader, PaymentMethod, SubmitButton },

        data() {
            return {
                pageDataFetched: false,
                availablePaymentMethods: [],
                ownerEmail: '',
            }
        },

  computed: {
    ...mapGetters("content", ["checkoutSharedContent"]),

    ...mapGetters("checkout", ["accountId", "paymentMethod"]),
  },

  methods: {
    ...mapMutations("checkout", [
      "setAccountId",
      "setIsPmUpdate",
      "setCurrencyIsoCode",
      "setWrittenLanguage",
    ]),

    ...mapMutations("billing", ["setCountry"]),

    ...mapActions("content", ["getCheckoutContent"]),

            initializeUpdatePaymentStoreData: async function(updatePaymentPageData) {
                this.setAccountId(updatePaymentPageData.data.account_id);
                this.setIsPmUpdate(updatePaymentPageData.data.is_pm_update);
                this.setCurrencyIsoCode(updatePaymentPageData.data.currency);
                this.setWrittenLanguage(updatePaymentPageData.data.which_written_language);
                this.setCountry(updatePaymentPageData.data.billing_country);
                this.availablePaymentMethods = updatePaymentPageData.data.available_payment_methods
                await this.getCheckoutContent();
            },

    submitUpdatePaymentData: async function () {
      try {
        let response = await axios({
          method: "POST",
          url: "/checkout/submit-update-payment-data",
          headers: { "Content-type": "application/json" },
          data: { paymentMethod: this.paymentMethod },
        });

        if (response.status === 200) {
          this.$router.push({ path: "/checkout/payment" });
          return;
        } else {
          throw "unhandledStatusCode";
        }
      } catch (e) {
        this.$router.push({
          path: "/message",
          query: { type: "errorCheckingOut" },
        });
        return;
      }
    },
  },

  async created() {
    try {
      let updatePaymentPageData = await axios(
        "/checkout/update-payment-page-data"
      );
      if (updatePaymentPageData.status === 200) {
        await this.initializeUpdatePaymentStoreData(updatePaymentPageData);
      } else {
        throw "unhandledStatusCode";
      }
    } catch (e) {
      this.$router.push({
        path: "/message",
        query: { type: "errorCheckingOut" },
      });
      return;
    }

    await this.$nextTick();
    this.pageDataFetched = true;

    try {
      analyticsTrack("Payment Updated", {
        "page name": document.title,
        url: window.location.pathname,
      });
    } catch (e) {
      // pass
    }
  },
};
</script>

<style lang="scss" scoped>
#update-payment-page {
  width: 100%;
  height: 100%;
  font-family: "Nitti Grotesk", sans-serif;
  font-style: normal;
  font-weight: normal;
  margin: 0 auto;
}

#body {
  max-width: 1080px;
  min-width: 320px;
  margin: 0 auto;
  margin-top: 44px;
  padding: 0px 12px;
}

.margin-top-20 {
  margin-top: 20px;
}

.black {
  color: black;
}

.bold {
  font-weight: bold;
}

.col {
  padding: 0px;
}

::v-deep {
  button {
    border: 1px solid #c1c9d1;
    border-radius: 5px;
    height: 48px;
    padding: 0 10px;
  }

  #select-payment-method {
    margin: 0px;
    padding-left: 0px;
    padding-top: 2%;

    .vs__dropdown-toggle {
      border: 1px solid #c1c9d1;
      height: 48px;
    }

    .vs__selected-options {
      overflow-x: hidden;
    }

    .vs__clear {
      display: none;
    }

    .vs__selected {
      white-space: nowrap;
    }

    .vs__dropdown-menu {
      width: 100%;
      min-width: 0px;

      padding-left: 0px 50px 0px 0px;
    }
  }
}
</style>
